/* =========================================================================
   alumbre. — comportamiento de la página de venta
   -------------------------------------------------------------------------
   Cada bloque va envuelto en `modulo()`, que atrapa sus errores: si uno falla
   (por ejemplo porque una app de terceros cambia el DOM) los demás siguen
   funcionando. Es la lección de la versión anterior, donde una excepción
   dejaba el resto de la página sin comportamiento.
   ========================================================================= */
(function () {
  'use strict';

  var raiz = document.documentElement;
  raiz.classList.add('js-dc'); // deja que el CSS asuma que hay JS
  var SIN_MOVIMIENTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function modulo(nombre, fn) {
    try { fn(); } catch (e) {
      if (window.console && console.warn) console.warn('[alumbre-dc] ' + nombre, e);
    }
  }
  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------ 1. Animar al entrar --- */
  modulo('revelar', function () {
    listo(function () {
      var piezas = $$('.dc-anim');
      if (!piezas.length) return;
      if (SIN_MOVIMIENTO || !('IntersectionObserver' in window)) {
        piezas.forEach(function (p) { p.classList.add('es-visible'); });
        return;
      }
      var vigia = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('es-visible');
          vigia.unobserve(e.target); // se anima una sola vez
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      piezas.forEach(function (p) { vigia.observe(p); });
    });
  });

  /* ------------------------------------------ 7. Llamadas a la acción ---- */
  modulo('cta', function () {
    // Selectores del botón propio de EasySell. Es el único camino que deja el
    // pedido enlazado con el flujo de la app; el resto son respaldos.
    var SEL_ES = '#es-popup-button, .es-popup-button, .es-buy-now, [data-es-button]';

    function abrirPedido(ev) {
      if (ev) { ev.preventDefault(); ev.stopPropagation(); }
      var nativo = $(SEL_ES);
      if (nativo) { nativo.click(); return; }
      var marco = $('[id$="__pedido_form"]') || $('#es-form') || $('.es-form');
      if (marco) {
        marco.scrollIntoView({ behavior: SIN_MOVIMIENTO ? 'auto' : 'smooth', block: 'center' });
        marco.classList.add('esta-resaltado');
        setTimeout(function () { marco.classList.remove('esta-resaltado'); }, 1800);
      }
    }
    window.dcAbrirPedido = abrirPedido;

    function enlazar() {
      $$('[data-dc-pedir]').forEach(function (b) {
        if (b.dataset.dcEnlazado) return;
        b.dataset.dcEnlazado = '1';
        b.addEventListener('click', abrirPedido);
      });
    }
    listo(enlazar);
    // La app pinta su botón tarde; se revisa un rato y luego se deja de mirar.
    var vueltas = 0;
    var id = setInterval(function () { enlazar(); if (++vueltas > 40) clearInterval(id); }, 700);
  });

  /* ---------------------------------------------- 8. Barra fija de compra */
  modulo('barra', function () {
    listo(function () {
      var barra = $('[data-dc-barra]');
      var ancla = $('[data-dc-ancla-cta]');
      if (!barra) return;
      document.body.classList.add('tiene-barra');

      function evaluar() {
        // El modal de EasySell es position:fixed, y en ese caso offsetParent
        // siempre vale null: hay que medirlo por sus dimensiones reales.
        var modal = document.getElementById('easysell-modal');
        var abierto = false;
        if (modal && getComputedStyle(modal).display !== 'none') {
          var rm = modal.getBoundingClientRect();
          abierto = rm.width > 0 && rm.height > 0;
        }
        var pasado = true;
        if (ancla) {
          var r = ancla.getBoundingClientRect();
          pasado = r.bottom < 10 || r.top > window.innerHeight; // el botón principal no está en pantalla (arriba o abajo)
        }
        // Cerca del formulario tampoco hace falta: ya lo tiene delante.
        var pedido = $('.dc-pedido');
        if (pasado && pedido) {
          var rp = pedido.getBoundingClientRect();
          if (rp.top < window.innerHeight * 0.9 && rp.bottom > 0) pasado = false;
        }
        barra.classList.toggle('esta-visible', pasado && !abierto);
      }
      evaluar();
      window.addEventListener('scroll', evaluar, { passive: true });
      window.addEventListener('resize', evaluar);
      setInterval(evaluar, 800); // el modal de la app abre sin avisar
    });
  });

  /* --------------------------------------------- 9. Cabecera al desplazar */
  modulo('cabecera', function () {
    listo(function () {
      var cab = $('[data-dc-cabecera]');
      if (!cab) return;
      function mirar() { cab.classList.toggle('esta-fija', window.scrollY > 12); }
      mirar();
      window.addEventListener('scroll', mirar, { passive: true });
    });
  });

  /* ------------------------------------------ 10. WhatsApp sin solaparse - */
  modulo('whatsapp', function () {
    function boton() { return $('body .whatsup-whatsapp-button, body a[href*="wa.me"]'); }
    function montar() {
      if (boton()) return;
      var t = document.getElementById('whatsup-whatsapp-button');
      if (t && t.content) document.body.appendChild(t.content.cloneNode(true));
    }
    function acomodar() {
      var b = boton();
      if (!b) return;
      var barra = $('[data-dc-barra]');
      var visible = barra && barra.classList.contains('esta-visible');
      if (visible) {
        var r = barra.getBoundingClientRect();
        b.style.bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
      } else {
        b.style.bottom = '';
      }
      b.style.zIndex = '2147482000'; // bajo la barra, sobre el resto
    }
    function iniciar() {
      montar(); acomodar();
      window.addEventListener('scroll', acomodar, { passive: true });
      window.addEventListener('resize', acomodar);
      setInterval(acomodar, 1000);
    }
    // Se da margen a la app para montarlo ella misma antes de intervenir.
    if (document.readyState === 'complete') setTimeout(iniciar, 2500);
    else window.addEventListener('load', function () { setTimeout(iniciar, 2500); });
  });
})();
